import { createFileRoute } from "@tanstack/react-router";
import { cityServiceHead } from "../lib/route-head";
import { CityServicePage } from "../components/city-service-page";
import { getCityService } from "../data/city-services";


export const Route = createFileRoute("/deck-cleaning-clifton-park-ny")({
  loader: async () => {
    const c = (await import("../data/city-services")).getCityService("deck-cleaning-clifton-park-ny")!;
    return { meta: c.meta, heroImage: c.heroImage, service: c.service, city: c.city, faqs: c.faqs };
  },
  head: ({ loaderData }) => cityServiceHead("deck-cleaning-clifton-park-ny", "deck-patio-cleaning", loaderData),
  component: RouteComponent,
});

function RouteComponent() {
  return <CityServicePage content={getCityService("deck-cleaning-clifton-park-ny")!} />;
}
